


import React, { useContext, useEffect, useReducer, useState } from "react";
import {  useLocation, useNavigate } from "react-router-dom";
import {  Nav, Tab } from "react-bootstrap";
import 'react-datepicker/dist/react-datepicker.css';


import { useDispatch, useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";

import { getVendorByPropIdApi } from "../../../../service/property/getVendorByProp";
import VendorTable from "../addAndListOfAllVendors/vendorTable";
import AssignedVendorTable from "./assignedVendorTable";
import AssigningVendorModal from "../assigningVendor/assigningVendorModal";
import AddVendorModal from "../addAndListOfAllVendors/addVendorModal";
import { setLoading } from "../../../../feature/authSlice";
import { findSubMenuByName } from "../../propertyList/MenuUtlis";
import { GetBeneRequestData } from "../../../../service/bankApi/getBeneRequestData";
import { GenerateBankTable } from "./generateBankTable";
const GenerateBankFile = () => {
  const {PropertyId,customerId} = useSelector(state => state.auth)
  const { permissions } = useSelector((state) => state.permissionsData);
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const[vendorListArr,setVendorListArr] = useState([])
  const[apiLoading,setApiLoading] = useState(false)
  const [pageViewVendor, setPageViewVendor] = useState(1);
  const [pageSizeViewVendor, setPageSizeViewVendor] = useState(10);
  const [totalPageViewVendor, setTotalPageViewVendor] = useState(1);
  const [searchValueViewVendor, setSearchValueViewVendor] = useState("");
  const [totalViewVendorCount, setTotalViewVendorCount] = useState(0);
  const handleSearchViewVendor = (e) => {
    // setPage(1)

    setSearchValueViewVendor(e.target.value);
    if (searchValueViewVendor.trim().length >= 2) {
      onChangePageViewVendor(1);
    }
  };

  const handleChangeRowsPerPageViewVendor= (e) => {
    // console.log(e)
    setSearchValueViewVendor("");
    setPageViewVendor(1);
    setPageSizeViewVendor(e.target.value);
  };

  const onChangePageViewVendor = (e, p) => {
    // setPage(p);
    setPageViewVendor(e);
  };
 
  const columns = [
    {
      Header: " ",
      Footer: "",
      accessor: "sd",
    },
   
    {
      Header: "Vendor Name ",
      Footer: "Vendor Name ",
      accessor: "VendorName",
    },
   
    {
      Header: "Beneficiary Name",
      Footer: "Beneficiary Name",
      accessor: "BeneficiaryName",
    },
    {
      Header: "Bank",
      Footer: "Bank",
      accessor: "Bank",
    },
    {
      Header: "IFSC",
      Footer: "IFSC",
      accessor: "IFSC",
    },
    { Header: "Account Number",
    Footer: "Account Number",
    accessor: "AccountNumber",

    },
    { Header: "Customer Account No",
    Footer: "Customer Account No",
    accessor: "CustomerAccountNumber",

    },
    { Header: "Last Paid",
    Footer: "Last Paid",
    accessor: "LastPaid",

    },
    { Header: "Validated",
      Footer: "Validated",
      accessor: "IsVerified",
      },
      { Header: "Result",
        Footer: "Result",
        accessor: "Result",
        },
  ];



  function onLoadData(){
    setApiLoading(true)
    var data ={
      "Filter": "",
      "OrderBy": "",
      "PageSize": pageSizeViewVendor,
      "PageNumber":pageViewVendor,
      "Keyword": searchValueViewVendor
    }

    dispatch(GetBeneRequestData(data,(res)=>{
        setApiLoading(false)
        console.log(res)
        setVendorListArr(res.data.result.List)
        setTotalViewVendorCount(res.data.result.TotalCount)
        if (parseInt(res?.data?.result?.TotalCount) % pageSizeViewVendor === 0) {
          setTotalPageViewVendor(parseInt(res?.data?.result?.TotalCount / pageSizeViewVendor))
        } else {
          setTotalPageViewVendor(parseInt(res?.data?.result?.TotalCount / pageSizeViewVendor+1))
        }
    },(res)=>{
        setApiLoading(false)
        
    }))
  }
  
  useEffect(()=>{
    // console.log("approvedViewVendorSubMenu",approvedViewVendorSubMenu)
onLoadData()
  },[searchValueViewVendor,pageViewVendor,pageSizeViewVendor])

  return (
    <>
      <ToastContainer />
      <div className="row d-flex justify-content-between">
        <div className="row">
        <div className="col-xxl-12">
          <div className="card">
          

            <Tab.Container defaultActiveKey="Pending">
              <div className="card-header border-0 pb-2 flex-wrap">
          <div className="d-flex">
          <h4 className="heading me-2">Beneficiary Account Validation</h4>
          </div>
             <div >
             </div>
              </div>
              <div className="card-body pt-2">

              <GenerateBankTable
                      column={columns}
                      rowsArr={vendorListArr}
                 
            showLoading={apiLoading}
                
                   handleChangeRowsPerPagePagination={
                    handleChangeRowsPerPageViewVendor
                  }
                  setVendorListArr={setVendorListArr}
                  setTotalPageViewVendor={setTotalPageViewVendor}
                  setTotalViewVendorCount={setTotalViewVendorCount}
                  searchValuePagination={searchValueViewVendor}
                  pageSizePagination={pageSizeViewVendor}
                  handleSearchPagination={handleSearchViewVendor}
                  totalCountPagination={totalPageViewVendor}
                  handleOnChangePagination={onChangePageViewVendor}
                  totalCount={totalViewVendorCount}
                  handleLoadData={onLoadData}
                  setPageSize={setPageSizeViewVendor}
                  // tab={tab}
                    />
              </div>
            </Tab.Container>
          </div>
        </div>
      </div>
      </div>
    </>
  );
};
export default GenerateBankFile;
